export default __webpack_public_path__ + "img/square_3.9fcbcedc1430470b3548da9c2b3cb539.jpg";